import React, { useState } from 'react';
import { format } from 'date-fns';
import {
  Button,
  Collapse,
  Icon,
  TableCell,
  TableRow
} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import { TextFormattedNumber } from 'components';
import {orderStatus} from 'helpers/orders';
import { convertUTCDateToLocalDate } from 'helpers/date';
import Order from '../../orders/Order';


const useStyles = makeStyles(() => ({
  blueCell: {
    backgroundColor: '#E7F0FF',
    borderTop: '1px solid #D0E9FF',
  },
  noBorders: {
    '& > *': {
      borderBottom: 'unset'
    },
  }
}));


const CustomerOrderRowCollapsible = ({order, labelId}) => {
  const classes = useStyles();
  const [openRow, setOpenRow] = useState(false);
  const {
    increment_id,
    status,
    created_at,
    grand_total
  } = order;

  const date = convertUTCDateToLocalDate(created_at);
  const formattedPurchaseDate = format(date, 'MM/dd/yyyy');
  const formattedPurchaseHours = format(date, 'hh:mm:ss aa');

  return (
    <>
      <TableRow
        hover
        role="checkbox"
        tabIndex={-1}
        className={`${openRow ? classes.blueCell : ''} ${classes.noBorders}`}
      >
        <TableCell component="th" id={labelId} scope="row" padding="none">
          <strong className="px-5">{increment_id}</strong>
        </TableCell>
        <TableCell>
          <div>{formattedPurchaseDate}</div>
          <div>{formattedPurchaseHours}</div>
        </TableCell>
        <TableCell>
          <TextFormattedNumber
            value={grand_total}
            prefix="$"
          />
        </TableCell>
        <TableCell>
          <span className={`${status} ${status ? 'indicator' : null}`}>{status ? orderStatus[status] : ''}</span>
        </TableCell>
        <TableCell align="center">
          <Button
            color="primary"
            onClick={(event) => {
              event.preventDefault();
              event.stopPropagation();
              setOpenRow(!openRow);
            }}
          >
            <Icon className="mr-2" fontSize="small">
              {`${openRow ? 'keyboard_arrow_down' : 'keyboard_arrow_right'}`}
            </Icon>
            {`${openRow ? 'View Less' : 'View More'}`}
          </Button>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell colSpan={5} padding="none" className={`${openRow ? classes.blueCell : ''}`}>
          <Collapse in={openRow} timeout="auto" unmountOnExit>
            <Order order={order} />
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
};

export default CustomerOrderRowCollapsible;
